import { render, staticRenderFns } from "./Producer.vue?vue&type=template&id=034bdd66&scoped=true"
import script from "./Producer.vue?vue&type=script&lang=js"
export * from "./Producer.vue?vue&type=script&lang=js"
import style0 from "./Producer.vue?vue&type=style&index=0&id=034bdd66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034bdd66",
  null
  
)

export default component.exports